import { FC, PropsWithChildren } from 'react';
import Flex from 'antd/es/flex';
import styles from './ButtonsFooter.module.css';

const ButtonsFooter: FC<PropsWithChildren<unknown>> = ({ children }) => {
  return (
    <div className={styles.footerContainer}>
      <Flex justify="stretch" gap="small" className={styles.footer}>
        {children}
      </Flex>
    </div>
  );
};
export default ButtonsFooter;
